<div class="modol_comp">
    <div class="modal-header pb-0 pt-0 d-flex">
        <button class="button-close" mat-button [mat-dialog-close]="false">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                <path
                    d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
            </svg>
        </button>
    </div>
    <div class="modal-body pt-0">
        <h2> {{ data?.view ? 'Super Admin User Details' : data?.user ? 'Edit Super Admin User' : 'Create Super Admin'}}</h2>

        <form class="" [formGroup]="submitForm">
            <div class="row mt-0">

                <div class="">
                    <div class="form-group col-12">
                        <div class="row">
                            <div class="col-md-6">
                                <label>First Name</label>
                                <input class="form-control mt-3" formControlName="firstName" placeholder="Enter First name" [readOnly]="data?.view"
                                    [ngClass]="{ 'is-invalid': submitted && f['firstName'].errors }">
                                <div *ngIf="submitted && f['firstName'].errors" class="invalid-feedback d-block">
                                    First name is required.
                                </div>
                            </div>

                            <div class="col-md-6">
                                <label>Last Name</label>
                                <input class="form-control mt-3" formControlName="lastName" placeholder="Enter Last name" [readOnly]="data?.view"
                                    [ngClass]="{ 'is-invalid': submitted && f['lastName'].errors }">
                                <div *ngIf="submitted && f['lastName'].errors" class="invalid-feedback d-block">
                                    Last name is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="form-group col-md-12 ">
                    <label class="">User Name</label>
                    <input class="form-control mt-3" formControlName="userName" type="text"
                        placeholder="Enter User name" [ngClass]="{ 'is-invalid': submitted && f['userName'].errors}">
                    <div *ngIf="submitted && f['userName'].errors" class="invalid-feedback" style="display: block;">
                        <ng-container *ngIf="f['userName'].errors['required']">
                            {{'User name is required.'}}
                        </ng-container>
                    </div>
                </div> -->

                <!-- Phone Number -->
                <div class="form-group col-md-12 country-code">
                    <label class="">Phone</label>
                    <div class="country-code-input pe-1">
                        <div class="d-flex align-items-center">
                            <div>+1</div> &nbsp;
                            <div class="drop-down-icon"></div>
                        </div>
                    </div>
                    <input type="text" class="form-control mt-3 ps-3 " formControlName="phoneNumber" [readOnly]="data?.view"
                        [maxlength]="maxLength.phoneNumber" [minlength]="maxLength.phoneNumber"
                        (keypress)="validationService.numberOnly($event)"
                        [ngClass]="{ 'is-invalid': submitted && f['phoneNumber']?.errors}"
                        placeholder="Enter phone number" [value]="phoneNumber" />
                    <div *ngIf=" submitted && f['phoneNumber']?.errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['phoneNumber']?.errors['required']">
                            {{validationErrorMessage.phoneNumber}} </div>
                    </div>
                    <div *ngIf=" submitted && f['phoneNumber']?.errors" class="invalid-feedback">
                        <div *ngIf="submitted && f['phoneNumber']?.errors['minlength']">
                            {{'Minimum 10 characters required.'}} </div>
                    </div>
                </div>

                <div class="form-group col-md-12">
                    <label class="">Email Address</label>
                    <input type="text" class="form-control mt-3" formControlName="email" [readOnly]="data?.view"
                        [ngClass]="{ 'is-invalid': submitted && f['email'].errors}" [maxlength]="maxLength.email"
                        (keydown.space)="$event.preventDefault()" placeholder="Enter email address" />
                    <div *ngIf="submitted && (f['email']?.errors && f['email']?.errors['required'])" class="invalid-feedback">
                        {{validationErrorMessage.email}} </div>
                    <div *ngIf="submitted && f['email']?.errors" class="invalid-feedback">
                        <div *ngIf="submitted && (f['email']?.errors['email'] || f['email']?.errors['pattern'] )">
                            {{validationErrorMessage.validEmail}}</div>
                    </div>
                </div>


                <div class="form-group col-md-12" formGroupName="address">
                    <div class="custom-check-address d-flex justify-content-between">
                        <label class="">Address</label>
                    </div>
                    <div class="row">
                        <div class="col-md-12 form-group">
                            <div class="search mt-2" *ngIf="!data?.view">
                                <app-address-auto-complete [selectedAddress]="selectedAddress"
                                    (placeSelected)="handleAddressChange($event, 1)"></app-address-auto-complete>
                                <img class="search-icon" src="assets/images/search.svg" width="18px" />
                            </div>
                        </div>
                        <div class="col-md-6 form-group">
                            <input type="text" class="form-control mt-3" formControlName="addressLine1" [readOnly]="data?.view"
                                (keypress)="validationService.excludeSpecificCharacters($event)"
                                [ngClass]="{ 'is-invalid': submitted && businessControl['addressLine1'].errors}"
                                placeholder="Enter address line 1" />
                            <div *ngIf="submitted && businessControl['addressLine1'].errors" class="invalid-feedback">
                                <div *ngIf="submitted && businessControl['addressLine1'].errors['required']">
                                    {{validationErrorMessage.address}}</div>
                            </div>
                            <!-- <input type="text" class="form-control mt-3"  formControlName="addressLine2" (keypress)="validationService.excludeSpecificCharacters($event)"  [ngClass]="{ 'is-invalid': submitted && f['addressLine2'].errors}"  placeholder="Enter address line 2" /> -->
                        </div>
                        <div class="col-md-6 form-group">
                            <input type="text" class="form-control mt-3" formControlName="addressLine2" [readOnly]="data?.view"
                                (keypress)="validationService.excludeSpecificCharacters($event)"
                                placeholder="Enter address line 2" />
                            <div *ngIf=" submitted && businessControl['addressLine2'].errors" class="invalid-feedback">
                                <div *ngIf="submitted && businessControl['addressLine2'].errors['required']">
                                    {{validationErrorMessage.address}}</div>
                            </div>
                        </div>
                        <div class="col-md-3 form-group">
                            <input type="text" class="form-control mt-3" formControlName="city" [readOnly]="data?.view"
                                [ngClass]="{ 'is-invalid': submitted && businessControl['city'].errors}"
                                placeholder="City" (keypress)="validationService.alphabetOnly($event)"
                                [required]="  " />
                            <div *ngIf=" submitted && businessControl['city'].errors" class="invalid-feedback">
                                <div *ngIf="submitted && businessControl['city'].errors['required']">
                                    {{validationErrorMessage.city}}</div>
                            </div>
                        </div>
                        <div class="col-md-3 form-group"> 
                            <input type="text" class="form-control mt-3" formControlName="state" [readOnly]="data?.view"
                                [ngClass]="{ 'is-invalid': submitted && businessControl['state'].errors}"
                                placeholder="State" (keypress)="validationService.alphabetOnly($event)" />
                            <div *ngIf=" submitted && businessControl['state'].errors" class="invalid-feedback">
                                <div *ngIf="submitted && businessControl['state'].errors['required']">
                                    {{validationErrorMessage.state}}</div>
                            </div>
                        </div>
                        <div class="col-md-3 form-group">
                            <input type="text" class="form-control mt-3" formControlName="country" [readOnly]="data?.view"
                                [ngClass]="{ 'is-invalid': submitted && businessControl['country'].errors}"
                                placeholder="Country" (keypress)="validationService.alphabetOnly($event)" />
                            <div *ngIf=" submitted && businessControl['country'].errors" class="invalid-feedback">
                                <div *ngIf="submitted && businessControl['country'].errors['required']">
                                    {{validationErrorMessage.country}}</div>
                            </div>
                        </div>
                        <!-- [required]="billingAddress?.isBilling==true" -->
                        <div class="col-md-3 form-group">
                            <input type="text" class="form-control mt-3" formControlName="zipCode" [readOnly]="data?.view"
                                [ngClass]="{ 'is-invalid': submitted && businessControl['zipCode'].errors}"
                                placeholder="Zipcode" />
                            <div *ngIf=" submitted && businessControl['zipCode'].errors" class="invalid-feedback">
                                <div *ngIf="submitted && businessControl['zipCode'].errors['required']">
                                    {{validationErrorMessage.zipCode}}</div>
                            </div>
                            <div *ngIf="submitted && businessControl['zipCode'].errors" class="invalid-feedback">
                                <div
                                    *ngIf="submitted && (businessControl['zipCode'].errors['zipCode'] || businessControl['zipCode'].errors['pattern'] )">
                                    {{validationErrorMessage.validZipCode}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="custom-control custom-checkbox d-flex align-items-center">
                            <input type="checkbox" [(ngModel)]="sameAddress" [ngModelOptions]="{standalone: true}" class="custom-control-input"  id="same-address" name="same-address" (change)="setServiceAddress($event)"/>
                            <label class="custom-control-label" for="same-adress">Service address same as business address </label>
                        </div> -->
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <div class="w-100 d-flex align-items-center justify-content-between" *ngIf="!data?.view; else view">
            <button type="button" class="btn cancel" [mat-dialog-close]="false">Cancel</button>
            <button type="submit" *ngIf="data?.user" class="btn delete-btn" [ngClass]="{'unblock': data?.user?.status !== 'Active'}" (click)="addPackage(true)">{{ data?.user?.status == 'Active' ? 'Block' : 'Unblock'}}</button>
            <button type="submit" class="btn delete" (click)="addPackage()">{{'Save'}}</button>
        </div>
        <ng-template #view>
            <div class="w-100 d-flex align-items-center justify-content-end" >
                <button type="button" class="btn delete" [mat-dialog-close]="false">Close</button>
            </div>

        </ng-template>
        
    </div>

</div>